// Справочники
import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    providerType: [],       // список типов поставщиков

    city: {
        list: [],           // список городов (неполный)
        pageSize: 10,       // размер страницы
        pagesInCache: 3,    // размер страницы
        search: {
            value: null,      // текущее значение для поиска
            page: 0,        // текущая страница
        },
    },

};

export const DictionarySlice = createSlice({
    name: 'dictionary',
    initialState,
    reducers: {
        setProviderType: (state, action) => {
            state.providerType = action.payload;
        },

        setCityList: (state, action) => {
            state.city.list = action.payload;
        },
        setCitySearchPage: (state, action) => {
            state.city.search.page = action.payload;
        },
        setCitySearch: (state, action) => {
            state.city.search = action.payload;
        },

    },
});

export const {
    setProviderType,
    setCityList, setCitySearchPage, setCitySearch
} = DictionarySlice.actions;

export const getProviderType = (state) => state.dictionary.providerType;
export const getCityList = (state) => state.dictionary.city.list;
export const getCitySearchValue = (state) => state.dictionary.city.search.value;
export const getCitySearchPage = (state) => state.dictionary.city.search.page;

export default DictionarySlice.reducer;